/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetConvenienceDoorQueryResponse,
  GetConvenienceDoorPathParams,
  GetConvenienceDoor404,
} from '../types/GetConvenienceDoor'

function getGetConvenienceDoorUrl({
  cstore_id,
}: {
  cstore_id: GetConvenienceDoorPathParams['cstore_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/places/convenience-doors/${cstore_id}/` as const,
  }
  return res
}

/**
 * @summary Get a convenience door
 * {@link /api/v1/places/convenience-doors/:cstore_id/}
 */
export async function getConvenienceDoor(
  { cstore_id }: { cstore_id: GetConvenienceDoorPathParams['cstore_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetConvenienceDoorQueryResponse,
    ResponseErrorConfig<GetConvenienceDoor404>,
    unknown
  >({
    method: 'GET',
    url: getGetConvenienceDoorUrl({ cstore_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
